module.exports = __webpack_public_path__ + "img/tuner_settings_equalizer_icon_250959-1.9f99b2aa.png";